import React from "react";
import DashboardCard from "../../components/PrivateLayerAdmin/DashboardCard";
import AssignmentSVG from "../../components/svg/AssignmentSVG";
import AssignmentMarkSVG from "../../components/svg/AssignmentMarkSVG";
import QuizzesSVG from "../../components/svg/QuizzesSVG";
import VideoSVG from "../../components/svg/VideoSVG";

export default function Dashboard() {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2  gap-6 p-8">
      <DashboardCard
        to="/admin/videos "
        cardIcon={<VideoSVG />}
        title={"Videos"}
      />
      <DashboardCard
        to="/admin/assignments"
        cardIcon={<AssignmentSVG />}
        title={"Assignment"}
      />
      <DashboardCard
        to="/admin/quizzes"
        cardIcon={<QuizzesSVG />}
        title={"Quizzes"}
      />
      <DashboardCard
        to="/admin/assignmentMark"
        cardIcon={<AssignmentMarkSVG />}
        title={"Assignment Mark"}
      />
    </div>
  );
}
